import { Capacitor } from "@capacitor/core";
import { Browser } from "@capacitor/browser";

// O servidor devolve links curtos (/files/...). Completa com o endereco do servidor.
const BACKEND_ORIGIN = process.env.REACT_APP_BACKEND_URL || "https://webapp-sitesync.onrender.com";

export function resolveFileUrl(url) {
  if (!url) return url;
  return url.startsWith("/") ? `${BACKEND_ORIGIN}${url}` : url;
}

// Abre um documento (PDF, imagem...). No app do iPhone abre no visualizador do sistema, com
// zoom, varias paginas e botao de compartilhar. No navegador abre numa aba nova.
export async function openDocument(url) {
  const full = resolveFileUrl(url);
  if (Capacitor.isNativePlatform()) {
    try {
      await Browser.open({ url: full });
      return;
    } catch (e) {
      // se o visualizador falhar, tenta o jeito comum abaixo
    }
  }
  window.open(full, "_blank", "noopener");
}

export function fileKind(name = "") {
  const ext = name.split(".").pop().toLowerCase();
  if (ext === "pdf") return "pdf";
  if (["png", "jpg", "jpeg", "webp", "heic"].includes(ext)) return "image";
  if (["xls", "xlsx", "csv"].includes(ext)) return "sheet";
  if (["doc", "docx", "txt"].includes(ext)) return "doc";
  return "file";
}

export function fmtSize(bytes) {
  if (!bytes && bytes !== 0) return "";
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} KB`;
  return `${(bytes / 1024 / 1024).toFixed(1)} MB`;
}
